import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './nav bar.css';
import logoImage from '../../assets/NewlogoRWE.png';

const NavBar = ({ onLearnMore }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img src={logoImage} alt="Real World Equity" className="nav-logo-img" />
          </Link>
        </div>
        
        {/* Hamburger Menu Button */}
        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          style={{
            display: isMobile ? 'block' : 'none',
            width: '32px',
            height: '32px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            position: 'relative',
            zIndex: 1001,
            padding: '0'
          }}
        >
          <span 
            className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}
            style={{
              position: 'absolute',
              left: '0',
              width: '100%',
              height: '2px',
              background: '#ffffff',
              top: '8px',
              transition: 'all 0.3s ease',
              borderRadius: '1px',
              transform: isMobileMenuOpen ? 'rotate(45deg) translate(6px, 6px)' : 'none'
            }}
          ></span>
          <span 
            className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}
            style={{
              position: 'absolute',
              left: '0',
              width: '100%',
              height: '2px',
              background: '#ffffff',
              top: '15px',
              transition: 'all 0.3s ease',
              borderRadius: '1px',
              opacity: isMobileMenuOpen ? '0' : '1'
            }}
          ></span>
          <span 
            className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}
            style={{
              position: 'absolute',
              left: '0',
              width: '100%',
              height: '2px',
              background: '#ffffff',
              top: '22px',
              transition: 'all 0.3s ease',
              borderRadius: '1px',
              transform: isMobileMenuOpen ? 'rotate(-45deg) translate(6px, -6px)' : 'none'
            }}
          ></span>
        </button>

        <ul className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <li className="nav-item">
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} 
              onClick={closeMobileMenu}
            >
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/assets" 
              className={`nav-link ${location.pathname === '/assets' ? 'active' : ''}`} 
              onClick={closeMobileMenu}
            >
              Assets
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/tokenization" 
              className={`nav-link ${location.pathname === '/tokenization' ? 'active' : ''}`} 
              onClick={closeMobileMenu}
            >
              Tokenization
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/team" 
              className={`nav-link ${location.pathname === '/team' ? 'active' : ''}`} 
              onClick={closeMobileMenu}
            >
              Team
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/news" 
              className={`nav-link ${location.pathname === '/news' ? 'active' : ''}`} 
              onClick={closeMobileMenu}
            >
              News
            </Link>
          </li>
          <li className="nav-item">
            <button className="nav-cta" onClick={() => { onLearnMore(); closeMobileMenu(); }}>Get Started</button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
